import { Context } from "../../../context.js";
import { isLink } from "../../../common/is-link.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#link-pseudo}
 */
export class Link extends PseudoClassSelector {
    static of() {
        return new Link();
    }
    constructor() {
        super("link");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return isLink(element) && !context.hasState(element, Context.State.Visited);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Link) {
    Link.parse = PseudoClassSelector.parseNonFunctional("link", Link.of);
})(Link || (Link = {}));
//# sourceMappingURL=link.js.map